import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const SearchContainer = styled.div`
    width: ${props => props.width || '100%'};
    padding: 10px 1rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 62.4375rem;
    border: 1px solid ${theme.colors.gray.Cinza_2};

    img {
        width: 1.25rem;
        height: 1.25rem;
    }

    .clear-icon {
        cursor: pointer;
        width: 1rem;
        height: 1rem;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;

        font-weight: 400;
        font-size: 0.875rem;
        line-height: 1.25rem;
        letter-spacing: 0.01em;
        font-family: 'Lato', sans-serif;

        ::placeholder {
            color: #8A92A2;
            text-align: left;
            font-weight: 400;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 0.01em;
            font-family: 'Lato', sans-serif;
        }
    }
`;

